package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class Event(
    val code: String,
    val name: String,
    val oprn: OPRN?,
    val ranking: Ranking?,
    val playoffs: Playoffs?,
    val matches: List<Schedule.Match>,
) {
    @Serializable
    data class OPRN(
        val npTotal: Double,
        val auto: Double,
        val teleop: Double,
        val endgame: Double,
    )

    @Serializable
    data class Playoffs(
        val alliance: Int,
        val member: AllianceMember,
        val placed: Int?,
        val npAverage: Double?,
    )

    enum class AllianceMember(val title: String) {
        CAPTAIN("Captain"),
        PICK_1("Pick 1"),
        PICK_2("Pick 2"),
        PICK_3("Pick 3"),
    }
}
